import React, { useEffect, useState } from "react";
import Helper from "../Helper";
import { APPLICATION_JSON, DEFAULT_IMAGE_140, DEFAULT_IMAGE_140_OSE, DEFAULT_IMAGE_400, DEFAULT_IMAGE_400_OSE } from "../../middleware/types";
import './OsePdpCss.css'
import { useLocation, Link } from "react-router-dom/cjs/react-router-dom.min";
import useStateRef from "react-usestateref";
import BreadCrumbsContainer from "../BreadCrumbs/BreadCrumbsContainer";
import AddToCartSuccessModal from "../PlpSection/AddToCartSuccessModal";
import AddShoppingListModal from "../PlpSection/AddShoppingListModal";
import CbLoginModal from "../CbLogin/CbLoginModal";
import ReviewSection from "./ReviewSection";
import { useDispatch, useSelector } from "react-redux";
import { updateProfileDetailsAction } from "../../middleware/updateProfileDetailsAction";
import RecommendedAccessories from "./RecommendedAccessories";
import CbCarouselHorizontal from "../CbCarouselVertical/CbCarouselHorizontal";
import ProductQuickViewModal from "../PlpSection/ProductQuickViewModal";
import Question from "./Question";
import YouMayAlso from "./YouMayAlso";
import ReactPlayerLoader from "@brightcove/react-player-loader";
import Zoom from 'react-img-hover-zoom'
import P65Warning from "./P65Warning";
import ProductModal from "./ProductModal";

const ProductDetailsContainer = ({ containerObject, templateName, contentId, dataZone }) => {

	const [productDetailsContent, setProductDetailsContent] = useState()
	const [pdfUrl, setPdfUrl] = useState()
	const [isLoading, setIsLoading] = useState(false);
	const [count, setCount] = useState(1);
	const [productcount, setproductCount, productcountref] = useStateRef({});
	const [triggerModal, setTriggerModal, triggerModalRef] = useStateRef(false);
	const [triggerAddToListModal, setAddToListModal, triggerAddToListModalRef] = useStateRef(false);
	const [productId, setProductId, productIdRef] = useStateRef();
	const [wishlistQty, setWishlistQty, wishlistQtyRef] = useStateRef(1);
	const location = useLocation()
	const [prodId, setProdId, prodIdRef] = useStateRef()
	const [domainName, setdomainName, domainNameRef] = useStateRef(containerObject.domainName ? containerObject.domainName : "")
	const [select, setSelect, selectRef] = useStateRef({})
	const [selectKey, setSelectKey, selectKeyRef] = useStateRef()
	const [selectValue, setselectValue, selectValueRef] = useStateRef()
	const [selectSkuResult, setSelectSkuResult, selectSkuResultRef] = useStateRef()
	const [showUnavaiable, setShowUnavaiable, ShowUnavaiableRef] = useStateRef()
	const [available, setavaiable, avaiableRef] = useStateRef()
	const [showMore, setShowMore, showMoreRef] = useStateRef()
	const [includedItemLength, setIncludedItemLength, includedItemLengthRef] = useStateRef()
	const [notIncludedItemLength, setNotIncludedItemLength, notIncludedItemLengthRef] = useStateRef()
	const [featuresLength, setFeaturesLength, featuresLengthRef] = useStateRef()
	const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
	const [productSpec, setProductSpec, productSpecRef] = useStateRef()
	const [avalClass, setAvalClass, avalClassRef] = useStateRef()
	const [productDetailsObj, setProductDetailsObj, productDetailsObjRef] = useStateRef()
	const [solrValue, setSolrValue, solrValueRef] = useStateRef("")
	const [relatedResourcesObj, setRelatedResourcesObj, relatedResourcesObjRef] = useStateRef()
	const [productTabsDescription, setProductTabsDescription, ProductTabsDescriptionRef] = useStateRef()
	const [productSpecficationcDetails, setProductSpecficationDetails, productSpecficationDetailsRef] = useStateRef()
	const [siteSpecDetails, setSiteSpecDetails, siteSpecDetailsRef] = useStateRef()
	const [productName, setProductName, productNameRef] = useStateRef()
	const dispatch = useDispatch();
	const [showReview, setShowReview, showReviewRef] = useStateRef();
	const [ratingSummary, setRatingSummary, ratingSummaryRef] = useStateRef();
	const [question, setQuestion, questionRef] = useStateRef();
	const [saleRetail, setSaleRetail, retailSaleRef] = useStateRef(false);
	const [baseRetail, setBaseRetail, retailBaseRef] = useStateRef(false);
	const [productImage, setProductImage, productImageRef] = useStateRef();
	const [selectedOneKey, setSelectedOneKey, selectedOneKeyRef] = useStateRef();
	const [selectedOneValue, setSelectedOneValue, selectedOneValueRef] = useStateRef();
	const [isDlproduct, setIsDlproduct, isDlproductRef] = useStateRef();
	const [productType, setProductType, productTypeRef] = useStateRef();
	const [screenWidth, setScreenWidth, screenWidthRef] = useStateRef("")
	const [warning, setWarning, warningRef] = useStateRef()
	const [releatedOrder, setReleatedOrder, releatedOrderRef] = useStateRef(containerObject.resourcesOrderList ? containerObject.resourcesOrderList : "")
	const [jsonId, setjsonId, jsonIdRef] = useStateRef()

	const onFailure = () => console.log("player error");
	const onSuccess = () => console.log("player success");


	var pathName = location.pathname
	var pathList = pathName.split("/")
	var ItemLength = 4;



	function handleFormEmpty(e) {
		if (document.querySelector('#quickViewModal')) {
			document.querySelector('#quickViewModal').addEventListener('hidden.bs.modal', function (e) {
				if (document.getElementById("addToCart")) {
					document.getElementById("addToCart").reset();
				}
			})
		}
	}
	function handleZoomImage() {
		console.log("handleZoomImage fired");
		let zoomTag = document.querySelectorAll(".zoom")
		console.log("handleZoomImage zoomTag", zoomTag);
		for (let i = 0; i < zoomTag.length; i++) {
			zoomTag[i].addEventListener("mousemove", function (event) {
				zoomIn(event);

			});
			zoomTag[i].addEventListener("mouseleave", function (event) {
				zoomOut(event);

			});
		}
		return true;

	}
	function zoomIn(e) {

		e.preventDefault();
		let offsetX;
		let offsetY;
		let img = e.target.src;
		let imgId = e.target.id;
		var zoomer = document.getElementById(`zoomImage_${imgId}`);
		img = zoomer.getAttribute("imageurl");
		zoomer.style.backgroundImage = `url(${img})`;
		e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX;
		e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX;
		let x = offsetX / zoomer.offsetWidth * 100
		let y = offsetY / zoomer.offsetHeight * 100
		zoomer.style.backgroundPosition = x + '% ' + y + '%';


	}



	function zoomOut(e) {

		let imgId = e.target.id;
		var zoomer = document.getElementById(imgId);

		zoomer.style.backgroundImage = ""
		zoomer.style.backgroundPosition = ""
		zoomer.style.removeProperty("backgroundImage");
		zoomer.style.removeProperty("backgroundPosition");
	}


	function handleFamilyVarientDefaultQty() {
		let qty = 1;
		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.oseFamilyProductPDP && containerObject.atgResponse.response.response.oseFamilyProductPDP.familyItem && containerObject.atgResponse.response.response.oseFamilyProductPDP.familyItem.familyProductList && containerObject.atgResponse.response.response.oseFamilyProductPDP.familyItem.familyProductList.map((oneItems) => {

			setproductCount({ ...productcountref.current, [oneItems.skuId]: qty })
		})
	}

	function handleWarning(head, description, icon) {
		0
		let map = {
			head: head,
			description: description,
			icon: icon
		}
		setWarning(map)
		document.getElementById("warning65").click()


	}


	function handleChangeCount(event) {
		let value = event.target.value;
		let qty = parseInt(value);
		setCount(qty)


	}


	function handleChangeCountForVarient(event) {
		let value = event.target.value;
		let qty = parseInt(value)
		let eventId = event.target.id;
		setproductCount({ ...productcountref.current, [eventId]: qty })


	}

	function replaceImage(event) {

		event.target.src = DEFAULT_IMAGE_140_OSE;

	}

	function replaceImageDLProduct(event) {

		event.target.src = DEFAULT_IMAGE_140;

	}

	function handleReplaceLargeImage(event) {
		var id = event.target.id;
		event.target.src = DEFAULT_IMAGE_400_OSE;
		var zoomImageId = "#zoomImage_".concat(id);

		var replace = document.querySelector(zoomImageId);
		if (replace) {
			let largeImage = replace.getAttribute("imageurl")
			const img = document.createElement('img');
			img.src = largeImage;

			img.onload = () => {
				// Image loaded successfully
				replace.setAttribute("imageurl", largeImage);
			};

			img.onerror = () => {
				// Image failed to load
				replace.setAttribute("imageurl", DEFAULT_IMAGE_400_OSE);
			};

		}

	}


	function handleProductImage(image) {
		setProductImage(image)
		document.getElementById("productImageModal").click()
	}
	function htmlRawContainerAccordian() {
		const expand = document.querySelectorAll(".expand h2");
		if (expand) {
			const expandContent = document.querySelectorAll(".expand .expand-content");
			for (let i = 0; i < expand.length; i++) {
				expand[i].addEventListener("click", function () {
					let expandTag = expand[i];
					let expandContentTag = expandContent[i]
					if (expandTag.classList.contains("ui-state-active")) {
						expandTag.classList.remove("ui-state-active")
						expandContentTag.classList.remove("d-block")
					} else {
						expandTag.classList.add("ui-state-active")
						expandContentTag.classList.add("d-block")
					}
				});
			}
		}


	}


	useEffect(() => {

		setScreenWidth(screen.width)
		htmlRawContainerAccordian()
		handleFamilyVarientDefaultQty()
		window.addEventListener('message', showData)
		handleFormEmpty();

		window.addEventListener('scroll', function () {

			// here we handle the sticky header for product
			var stickyNav = document.getElementById("prod-sticky-nav");
			var stickyNavSec = window.innerWidth > 767 ? document.getElementById("prod-sticky-nav") : document.getElementById("pdp-nav");
			var stickyNavTop = stickyNavSec.offsetTop;
			var sitckyNavHeight = stickyNavSec.offsetHeight + 1;
			var body = document.getElementById('body').offsetTop - 10;
			if (body != null && stickyNavSec) {
				if (window.scrollY > stickyNavTop) {
					stickyNav.classList.add('sticky-nav');
					stickyNav.classList.add('d-lg-inline-flex');
				} else {
					stickyNav.classList.remove('sticky-nav');
					stickyNav.classList.remove('d-lg-inline-flex');
				}
			}

		});
	}, [])

	function handleJsonLd() {

		let jsonIdMap = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.schemaJson && containerObject.atgResponse.response.response.schemaJson.schemaJson ? containerObject.atgResponse.response.response.schemaJson.schemaJson
			: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyProduct && containerObject.atgResponse.response.response.familyProduct.schemaJson && containerObject.atgResponse.response.response.familyProduct.schemaJson.schemaJson ? containerObject.atgResponse.response.response.familyProduct.schemaJson.schemaJson
				: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.schemaJson && containerObject.atgResponse.response.response.familyVariyantProductDetails.schemaJson.schemaJson ? containerObject.atgResponse.response.response.familyVariyantProductDetails.schemaJson.schemaJson : ""
		console.log("json IdRef ", jsonIdMap);


	}

	function dlProduct() {
		setIsDlproduct(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.isDLProduct);
	}
	function prodType() {
		setProductType(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.prodType ? containerObject.atgResponse.response.response.prodType :
			containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryJson && containerObject.atgResponse.response.response.standardResult.galleryJson.prodType ? containerObject.atgResponse.response.response.standardResult.galleryJson.prodType :
				containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.galleryJsonResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.galleryJsonResult.prodType ? containerObject.atgResponse.response.response.familyVariyantProductDetails.galleryJsonResult.prodType : "")
	}




	function showData(event) {
		setRatingSummary(event.data.ratingSummary)
		setShowReview(event.data.showReview)
		setQuestion(event.data.questionAndAnswer)
	}

	function handleRetailPrice(data, type) {

		let regSalePrice = data && data.regSalePrice && data.regSalePrice;
		let retailPrice = data && data.retailPrice && data.retailPrice;
		let regBasePrice = data && data.regBasePrice && data.regBasePrice;
		let profileType = type && type;
		if (regBasePrice) {
			if (regBasePrice.includes("$")) {
				regBasePrice = regBasePrice.replace("$", "");
			}
			if (regBasePrice.includes(",")) {
				regBasePrice = regBasePrice.replace(",", "");
			}
		}

		if (retailPrice) {
			if (retailPrice.includes("$")) {
				retailPrice = retailPrice.replace("$", "");
			}
			if (retailPrice.includes(",")) {
				retailPrice = retailPrice.replace(",", "");
			}
		}

		if (regBasePrice === retailPrice) {
			return "equal"
		} else {
			return "notEqual"
		}
	}







	const iconObjectMap = {

		"exclamation-triangle-icon": <i><img alt="exclamation triangle icon" src={`${domainNameRef.current}/images/icons/exclamation-triangle-icon.svg`} /></i>,
		"document-icon": <i><img alt="document icon" src={`${domainNameRef.current}/images/icons/document-icon.svg`} /></i>,
		"magnify-icon": <i><img alt="magnify icon" src={`${domainNameRef.current}/images/icons/magnify-icon.svg`} /></i>,
		"video-play-icon": <i><img alt="magnify icon" src={`${domainNameRef.current}/images/icons/video-play-icon.svg`} /></i>,
		"life-care-icon": <i><img alt="life care icon" src={`${domainNameRef.current}/images/icons/life-care-icon.svg`} /></i>,
	}
	function handleSetProductId() {
		if (containerObject.atgResponse.result == "success") {
			setProductId(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.product ? containerObject.atgResponse.response.response.product : "")
			setProdId(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.product ? containerObject.atgResponse.response.response.product : "")
		}

	}


	function handleSetProductId() {
		if (containerObject.atgResponse.result == "success") {
			setProductId(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.product ? containerObject.atgResponse.response.response.product : "")
			setProdId(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.product ? containerObject.atgResponse.response.response.product : "")
		}

	}


	useEffect(() => {
		setProductDetailsContent(containerObject && containerObject.atgResponse && containerObject.atgResponse.response && containerObject.atgResponse.response.response && containerObject.atgResponse.response ? containerObject.atgResponse.response.response : "")
		var pdfurl = containerObject && containerObject.atgResponse && containerObject.atgResponse.response && containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.teacherResource && containerObject.atgResponse.response.response.teacherResource.detailPDF && containerObject.atgResponse.response.response.teacherResource.detailPDF.pdfPath ? containerObject.atgResponse.response.response.teacherResource.detailPDF.pdfPath : ""

		setPdfUrl(containerObject && containerObject.atgResponse && containerObject.atgResponse.response && containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.teacherResource && containerObject.atgResponse.response.response.teacherResource.detailPDF ? containerObject.atgResponse.response.response.teacherResource.detailPDF.pdfPath : "")
		if (containerObject && containerObject.atgResponse && containerObject.atgResponse.response && containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.dataLayer) {
			window.dataLayer = window.dataLayer || []
			if (window.dataLayer.length <= 0) {
				window.dataLayer.push(containerObject.atgResponse.response.response.dataLayer)
				// console.log('dataLayer...', window.dataLayer)
			}
		}
	}, [containerObject, profileDetails])

	useEffect(() => {
		dlProduct()
		prodType()
		handleJsonLd()
		selectedSku()
		handleDisplayPrice()
		handleShowMoreLength()

		relatedResources()
		handleSetProductId()


		handleFamilyTabsRelatedResources()

	}, [containerObject])


	function handleFamilyTabsRelatedResources() {
		let familyTabsDescription;
		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.skus.map((oneSku, index) => {

			oneSku && oneSku.skuId === selectSkuResultRef.current ?
				familyTabsDescription = oneSku.productDescription && oneSku.productDescription : ""
		})
		if (familyTabsDescription) {
			setProductTabsDescription(familyTabsDescription)
		}
	}




	function relatedResources() {

		var cbProductRelatedResources = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.relatedResources
			&& (containerObject.atgResponse.response.response.standardResult.tabsResult.relatedResources.contentItemList && containerObject.atgResponse.response.response.standardResult.tabsResult.relatedResources.contentItemList.length > 0 || containerObject.atgResponse.response.response.standardResult.tabsResult.relatedResources.resourceItemsList && containerObject.atgResponse.response.response.standardResult.tabsResult.relatedResources.resourceItemsList.length > 0) && containerObject.atgResponse.response.response.standardResult.tabsResult.relatedResources

		var familyVarientRelatedResources = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.relatedResources && (containerObject.atgResponse.response.response.familyVariyantProductDetails.relatedResources.contentItemList
			&& containerObject.atgResponse.response.response.familyVariyantProductDetails.relatedResources.contentItemList.length > 0 || containerObject.atgResponse.response.response.familyVariyantProductDetails.relatedResources.resourceItemsList && containerObject.atgResponse.response.response.familyVariyantProductDetails.relatedResources.resourceItemsList.length > 0) && containerObject.atgResponse.response.response.familyVariyantProductDetails.relatedResources

		if (cbProductRelatedResources) {
			setRelatedResourcesObj(cbProductRelatedResources)
		}
		if (familyVarientRelatedResources) {
			setRelatedResourcesObj(familyVarientRelatedResources)
		}

	}

	async function siteSpec(inputMap) {
		var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/sitespect-details`

		var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))

		setSiteSpecDetails(res.response)
		// console.log("resfromSpec", res);
	}
	async function specification(event) {
		let specificationId = event.target.value
		var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/cart/specificationDetails/${specificationId}`

		var res = await Helper.fetchCallFunction(Url, "GET", false, APPLICATION_JSON, null)
		setProductSpecficationDetails(res)
		handleShowMoreLength()
		// console.log("resfromSpecificationProduct", res);

	}


	function handleShowMoreLength() {

		var CBSIncludedItem = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.includedItem && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.includedItem.length
		var CBSNotIncludedItem = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.notIncludedItem && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.notIncludedItem.length
		var CBSFeaturedItem = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.specificationList && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.specificationList.length
		var familyProductincludedItem;
		var familyProductnotIncludedItem;
		var familyProductfeaturedItem;

		var familyVarientincludedItem = productSpecficationDetailsRef.current && productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.includedItem && productSpecficationDetailsRef.current.familyProduct.includedItem.length;
		var familyVarientnotIncludedItem = productSpecficationDetailsRef.current && productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.notIncludedItem && productSpecficationDetailsRef.current.familyProduct.notIncludedItem.length;
		var familyVarientfeaturedItem = productSpecficationDetailsRef.current && productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.specificationList && productSpecficationDetailsRef.current.familyProduct.specificationList.length;


		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.skus.map((oneSku, index) => {

			oneSku && oneSku.skuId === selectSkuResultRef.current ?
				familyProductincludedItem = oneSku.specifications && oneSku.specifications.whatsIncludedList && oneSku.specifications.whatsIncludedList.length : ""
		})
		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.skus.map((oneSku, index) => {

			oneSku && oneSku.skuId === selectSkuResultRef.current ?
				familyProductnotIncludedItem = oneSku.specifications && oneSku.specifications.whatsExcludedList && oneSku.specifications.whatsExcludedList.length : ""
		})

		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.skus.map((oneSku, index) => {

			oneSku && oneSku.skuId === selectSkuResultRef.current ?
				familyProductfeaturedItem = oneSku.specifications && oneSku.specifications.specs && oneSku.specifications.specs.length : ""
		})

		if (CBSIncludedItem) {

			setIncludedItemLength(CBSIncludedItem);
			setShowMore({ ...showMoreRef.current, ["includedItem"]: ItemLength })
		}
		if (familyProductincludedItem) {

			setIncludedItemLength(familyProductincludedItem);
			setShowMore({ ...showMoreRef.current, ["includedItem"]: ItemLength })
		}
		if (familyVarientincludedItem) {

			setIncludedItemLength(familyVarientincludedItem);
			setShowMore({ ...showMoreRef.current, ["includedItem"]: ItemLength })
		}
		if (CBSNotIncludedItem) {

			setNotIncludedItemLength(CBSNotIncludedItem);
			setShowMore({ ...showMoreRef.current, ["notIncludedItem"]: ItemLength })
		}
		if (familyProductnotIncludedItem) {

			setNotIncludedItemLength(familyProductnotIncludedItem);
			setShowMore({ ...showMoreRef.current, ["notIncludedItem"]: ItemLength })
		}
		if (familyVarientnotIncludedItem) {

			setNotIncludedItemLength(familyVarientnotIncludedItem);
			setShowMore({ ...showMoreRef.current, ["notIncludedItem"]: ItemLength })
		}
		if (CBSFeaturedItem) {

			setFeaturesLength(CBSFeaturedItem);
			setShowMore({ ...showMoreRef.current, ["featuredItem"]: ItemLength })
		}
		if (familyProductfeaturedItem) {

			setFeaturesLength(familyProductfeaturedItem);
			setShowMore({ ...showMoreRef.current, ["featuredItem"]: ItemLength })
		}
		if (familyVarientfeaturedItem) {

			setFeaturesLength(familyVarientfeaturedItem);
			setShowMore({ ...showMoreRef.current, ["featuredItem"]: ItemLength })
		}

	}
	function handleShowMore(key) {
		var includedItem = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.includedItem && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.includedItem.length
		var notIncludedItem = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.notIncludedItem && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.notIncludedItem.length

		var featuredItem = containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.specificationList && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.specificationList.length

		var familyVarientincludedItem = productSpecficationDetailsRef.current && productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.includedItem && productSpecficationDetailsRef.current.familyProduct.includedItem.length;
		var familyVarientnotIncludedItem = productSpecficationDetailsRef.current && productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.notIncludedItem && productSpecficationDetailsRef.current.familyProduct.notIncludedItem.length;
		var familyVarientfeaturedItem = productSpecficationDetailsRef.current && productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.specificationList && productSpecficationDetailsRef.current.familyProduct.specificationList.length;


		var familyProductIncludedItem;
		var familyProductNotIncludedItem;
		var familyProductFeaturedItem;


		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.skus.map((oneSku, index) => {

			oneSku && oneSku.skuId === selectSkuResultRef.current ?
				familyProductIncludedItem = oneSku.specifications && oneSku.specifications.whatsIncludedList && oneSku.specifications.whatsIncludedList.length : ""
		})
		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.skus.map((oneSku, index) => {

			oneSku && oneSku.skuId === selectSkuResultRef.current ?
				familyProductNotIncludedItem = oneSku.specifications && oneSku.specifications.whatsExcludedList && oneSku.specifications.whatsExcludedList.length : ""
		})

		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.skus.map((oneSku, index) => {

			oneSku && oneSku.skuId === selectSkuResultRef.current ?
				familyProductFeaturedItem = oneSku.specifications && oneSku.specifications.specs && oneSku.specifications.specs.length : ""
		})



		if (key == "includedItem") {

			setIncludedItemLength(0)
			setShowMore({ ...showMoreRef.current, ["includedItem"]: includedItem })
		}
		if (key == "notIncludedItem") {

			setNotIncludedItemLength(0)
			setShowMore({ ...showMoreRef.current, ["notIncludedItem"]: notIncludedItem })
		}
		if (key == "featuredItem") {

			setFeaturesLength(0);
			setShowMore({ ...showMoreRef.current, ["featuredItem"]: featuredItem })
		}
		if (key == "familyProductIncludedItem") {

			setIncludedItemLength(0)
			setShowMore({ ...showMoreRef.current, ["includedItem"]: familyProductIncludedItem })
		}
		if (key == "familyProductNotIncludedItem") {

			setNotIncludedItemLength(0)
			setShowMore({ ...showMoreRef.current, ["notIncludedItem"]: familyProductNotIncludedItem })
		}
		if (key == "familyProductFeaturedItem") {

			setFeaturesLength(0);
			setShowMore({ ...showMoreRef.current, ["featuredItem"]: familyProductFeaturedItem })
		}
		if (key == "familyVarientincludedItem") {

			setIncludedItemLength(0)
			setShowMore({ ...showMoreRef.current, ["includedItem"]: familyVarientincludedItem })
		}
		if (key == "familyVarientnotIncludedItem") {

			setNotIncludedItemLength(0)
			setShowMore({ ...showMoreRef.current, ["notIncludedItem"]: familyVarientnotIncludedItem })
		}
		if (key == "familyVarientfeaturedItem") {

			setFeaturesLength(0);
			setShowMore({ ...showMoreRef.current, ["featuredItem"]: familyVarientfeaturedItem })
		}
	}

	function triggerAddToListModals() {
		setAddToListModal(true)
	}

	function handleError(message) {

		if (message) {
			var error = document.getElementById('add-item-errormessage');
			error.classList.remove("d-none");
			error.classList.add("d-block");
			var cartMessage = document.getElementById('addToCartErrorMessage');
			cartMessage.innerHTML = message;
		} else {
			var error = document.getElementById('add-item-errormessage');
			error.classList.remove("d-block");
			error.classList.add("d-none");
			var cartMessage = document.getElementById('addToCartErrorMessage');
			cartMessage.innerHTML = "";
		}


	}


	function handleSelectRange(key, value) {

		setavaiable()
		setSelectSkuResult()
		setAvalClass()
		setselectValue()
		var selectKey = [];
		var selectValue = [];
		setSelectedOneKey(key)
		setSelectedOneValue(value)
		setSelect({ ...selectRef.current, [key]: value })
		Object.entries(selectRef.current).forEach(([key, value]) => {
			selectKey.push(key)
			selectValue.push(value);
		});
		setSelectKey(selectKey)
		setselectValue(selectValue)
		handleDisplayPrice()
		defaultSelectedSku()
	}

	function defaultSelectedSku() {
		if (selectSkuResultRef.current) {
		} else {
			setavaiable()
			setSelectSkuResult()
			setAvalClass()
			setselectValue()

			handleUnavailableProduct()
			handleDisplayPrice()
		}
		handleFamilyTabsRelatedResources()


	}


	function selectedSku() {
		var selectKey = [];
		var selectValue = [];

		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.selectedSku && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.selectedSku.variant && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.selectedSku.variant.map((oneSelectedSKu) => {
			setSelect({ ...selectRef.current, [oneSelectedSKu.groupId]: oneSelectedSKu.value })
			selectKey.push(oneSelectedSKu.groupId)
			selectValue.push(oneSelectedSKu.value)
		})
		setSelectKey(selectKey)
		setselectValue(selectValue)

	}

	function handleUnavailableProduct() {

		var selectKey = [];
		var selectValue = [];
		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.skus.map((oneVarient, index) => {

			if (oneVarient.variantsMap[selectedOneKeyRef.current] == selectedOneValueRef.current) {
				if (selectValueRef.current) {

				}
				else {
					Object.entries(oneVarient.variantsMap).forEach(([key, value]) => {

						setSelect({ ...selectRef.current, [key]: value })
						selectKey.push(key)
						selectValue.push(value)
					});
					setSelectKey(selectKey)
					setselectValue(selectValue)
				}

			}


		})

	}

	function handleDisplayPrice() {


		containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.skus.map((oneVarient, index) => {

			handleSelectSku(oneVarient)

		})
	}


	function handleSelectSku(oneVarient) {
		var selectValue = [];
		var count = 0;

		// if (selectValueRef.current.length > 1) {

		Object.entries(oneVarient.variantsMap).forEach(([key, value]) => {
			selectValue.push(value);
		});
		selectValue.map((oneValue) => {
			if (selectValueRef.current.includes(oneValue)) {
				count++;
			}
		})
		if (count == (selectValueRef.current.length - 1)) {
			var selected = [];
			if (avaiableRef.current) {
				avaiableRef.current.map((oneAvailable) => {
					selected.push(oneAvailable);
				})

			}

			selectValue.map((oneValue) => {
				if (avaiableRef.current && avaiableRef.current.includes(oneValue)) {
					//nothing we need to add because it already exit in the list

				} else {
					selected.push(oneValue)
				}
				setavaiable(selected)
			})


		}
		if (selectValueRef.current.length == count) {
			setSelectSkuResult(oneVarient.skuId)
			setAvalClass(oneVarient.inventoryStatus)
		}

	}


	function handleWishList(id, wishlistCount) {
		setProductId(id)
		setWishlistQty(wishlistCount)
	}


	useEffect(() => {
		window.addEventListener('scroll', function () {

			if (window.scrollY > 200) {
				var addToCartRibbon = document.getElementById('prod-sticky-nav')
				if (addToCartRibbon) {
					addToCartRibbon.classList.add('sticky-nav');
					addToCartRibbon.classList.add('d-lg-inline-flex');
				}
			} else {
				var addToCartRibbon = document.getElementById('prod-sticky-nav')
				if (addToCartRibbon) {
					addToCartRibbon.classList.remove('sticky-nav');
					addToCartRibbon.classList.remove('d-lg-inline-flex');
				}
			}

		});

	}, [])



	function Decrement() {
		if (count > 1) {
			let qty = count - 1;
			setCount(qty);
		}

	}
	function Increment() {
		if (count < 999) {
			let qty = count + 1;
			setCount(qty);
		}
	}

	function handleDecrement(productId) {

		if (productId != " ") {
			var count = parseInt(document.getElementById(productId).getAttribute("value"))
			if (count > 1) {
				count = count - 1;
				setproductCount({ ...productcountref.current, [productId]: count })
			}
		}


	}
	function handleIncrement(productId) {
		if (productId != " ") {
			var count = parseInt(document.getElementById(productId).getAttribute("value"))
			if (count < 999) {
				count = count + 1;
				setproductCount({ ...productcountref.current, [productId]: count })
			}
		}

	}

	function scrollToView(id) {
		var mapConfiguration = {
			"description": "pdp-desc-body",
			"specification": "pdp-spec-body",
			"reviews": "pdp-reviews-body",
			"qAndA": "pdp-qAndA-body"

		}


		if (screenWidthRef.current < 1024) {
			var viewId = mapConfiguration[id];
			console.log("scrollToView viewId", viewId);
			var scrollId = document.getElementById(viewId);
			console.log("scrollToView scrollId", scrollId);
			if (scrollId) {
				//scrollId.classList.add("show")
				if (!scrollId.classList.contains("show")) {
					let scrollViewId = id + "_accordion_button";
					if(document.getElementById(scrollViewId)){
					document.getElementById(scrollViewId).click();
					}
				}
			}
		}
		setTimeout(() => {
			let stickyNav;
			if (window.innerWidth > 767) {
				stickyNav = document.getElementById("prod-sticky-nav");
			} else {
				stickyNav = document.getElementById("pdp-nav");
			}
			var stickyNavSec = stickyNav.offsetTop;
			console.log("scrollToView stickyNavSec", stickyNavSec);
			if (stickyNavSec > 0) {
				window.scrollTo({
					top: parseInt(stickyNavSec),
					behavior: 'smooth'
				})
			}
			console.log("scrollToView id", id);
			console.log("scrollToView document.getElementById(id).offsetTop", document.getElementById(id).offsetTop);
			var scrollPos = document.getElementById(id).offsetTop - stickyNav.offsetHeight;
			console.log("scrollToView scrollPos", scrollPos);
			const stickynav = stickyNav.offsetHeight
			console.log("scrollToView stickynav", stickynav);
			if (stickyNavSec > 0) {
				scrollPos = scrollPos - stickynav;
			}
			scrollTop(scrollPos)
		}, 500);


	}


	const scrollTop = (length) => {
		window.scrollTo({
			top: parseInt(length),
			behavior: 'smooth'
		})
	};




	async function handleAddToCart(event) {
		event.preventDefault();
		var message = "";
		handleError(message);
		var actionUrl = "api/rest/cb/cart/pdp/add-to-cart";
		var formData = new FormData(event.target);
		var productId = formData.get("productId")
		var quantity = formData.get("quantity")

		const cartDetailMap = {
			addItemCount: "1",
			productId: productId,
			catalogRefId: productId,
			quantity: quantity,
			allowDLAddToCart: "true"
		}
		var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
		var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(cartDetailMap))
		if (res.result == "success") {
			var response = JSON.parse(res.response).response;
			setProductName(response.response.productName)
			let count = parseInt(response.response.quantity)
			setCount(count)
			setProductId(response.response.productId)
			dispatch(updateProfileDetailsAction(true, "cart"));
			setTriggerModal(true)
			document.getElementById("pdpAddToCartSuccessModal").click()
		}
		else {
			handleError(res.errorMessage)
		}
	}


	function handleQuickView(quickViewDetails) {
		setProductDetailsObj(quickViewDetails)

	}

	function handleQuickViewCount(prodCount) {
		if (prodCount != 0) {
			setSolrValue(prodCount)
		} else {
			setSolrValue("")
		}


	}
	function cartProductDetailsCallBack(quickViewDetails) {

	}

	useEffect(() => {
		const titleElement = document.querySelector('title')
		if (containerObject.currentProductName) {
			titleElement.innerHTML = containerObject.currentProductName + " | Carolina Biological Supply"
			console.log('titleElement ---- productDetails if ', titleElement)
		} else {
			titleElement.innerHTML = "Carolina Biological Supply"
			console.log('titleElement ---- productDetails else ', titleElement)
		}
	}, [containerObject])



	return (<>

		{containerObject.atgResponse.result == "success" ? <>
			{<div className="script" dangerouslySetInnerHTML={{ __html: jsonIdRef.current }}></div>}
			<p id="warning65" className="m-0" data-bs-toggle="modal" data-bs-target="#prop65" data-bs-dismiss="modal" title="" class="fwb icon-content"></p>
			<ProductModal domainName={domainNameRef.current} productImage={productImageRef.current} />
			<P65Warning message={warningRef.current} isCart={false} />
			<CbLoginModal triggerAddToList={true} triggerAddToListModals={triggerAddToListModals} />
			<p className="m-0" data-bs-toggle="modal" data-bs-target="#newListModalww" data-bs-dismiss="modal" id="afterLoginAddToList"></p>
			<AddShoppingListModal productId={productIdRef.current ? productIdRef.current : ""} quantity={wishlistQtyRef.current ? wishlistQtyRef.current : ""} />
			{triggerModalRef.current == true ? <AddToCartSuccessModal productId={productIdRef.current} quantity={count} productName={productNameRef.current} /> : ""}
			<p className="m-0" id="pdpAddToCartSuccessModal" aria-current="page" data-bs-toggle="modal" data-bs-target="#addToCartSuccess"></p>
			<p className="m-0" id="productImageModal" aria-current="page" data-bs-toggle="modal" data-bs-target="#productImage"></p>
			<div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row  max-width-ose `} >


				{/* CBS product started here */}

				{productTypeRef.current && productTypeRef.current == "CBS Product" ?
					<>


						<div id="body"  className={`row os-pdp-section ${screenWidthRef.current < 810 ? "p-0 m-0 g-0" : "px-0"}`} >
							<div className="col-12 order-2 order-md-1 ">

								<div className="row printPdpHeader" id="prod-sticky-nav">
									<div className="col prod-nav-title">
										<h1 dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : "" }} />

									</div>
									<div className="col-12 pdp-nav" id="pdp-nav">
										<ul className="row prod-nav-group list-unstyled g-0">
											<li className="col-md-6 col-12 prod-nav-item hide-on-sticky">

												<div className="m0"><span className="fwb ftms">Item #:</span> <span id="pdp-skuId">{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.product ? containerObject.atgResponse.response.response.product : ""}</span></div>
											</li>
											<li className="col prod-nav-item bg-light-grey">
												<Link className="pdp-scroll-to" onClick={() => scrollToView("description")}>
													Description
												</Link>
											</li>

											<li className="col prod-nav-item bg-light-grey">
												<Link className="pdp-scroll-to"
													onClick={() => scrollToView("specification")}
												>
													Specifications
												</Link>
											</li>

										</ul>
									</div>
								</div>
							</div>
							<div className="col-12 col-md-6 order-1 order-md-2 my-5">
								<div id="pdp-gallery" className="carousel carousel-dark slide" data-bs-ride="false" data-bs-interval="false">
									<div className="carousel-inner pdp-gallery-slides">
										<div className="carousel-item active modalImage_1" id="modal-image1" onClick={() => handleProductImage(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryJson.largeImg)} >
											{/* <img id="1" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} style={{ "width": "400px", "height": "400px" }} className="printShowImage" onError={handleReplaceLargeImage} src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryJson.mediumImg)} />
											<Zoom
												img={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryJson.mediumImg)}
												zoomScale={2}
												width={screenWidthRef.current > 810 ? 400 : 300}
												height={screenWidthRef.current > 810 ? 400 : 300}
												className="imagepointer replaceImage_1 printHideImage"
											/> */}
											<div id="zoomImage_1" className="zoom cbProductZoom " imageurl={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryJson.largeImg)} >
												<img width={screenWidthRef.current > 810 ? 400 : 300} loading='lazy' height={screenWidthRef.current > 810 ? 400 : 300} id="1" alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""}  onError={handleReplaceLargeImage} src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryJson.mediumImg)} onLoad={handleZoomImage} />
											</div>
											{handleZoomImage() == true ? "" : ""}
										</div>




										{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult.galleryJson.addlTopImagesList.map((addlImg, index) => {
											return (<>
												<div id={`modal-image${index + 2}`} className={`carousel-item modalImage_${index + 2}`} onClick={() => handleProductImage(addlImg.addlTopLargeImg)} >
													{/* <img id={index + 2} alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} style={{ "width": "400px", "height": "400px" }} className="printShowImage" onError={handleReplaceLargeImage} src={domainNameRef.current.concat(addlImg.addlTopMediumImg)} />

													<Zoom

														img={domainNameRef.current.concat(addlImg.addlTopMediumImg)}
														zoomScale={3}
														width={screenWidthRef.current > 810 ? 400 : 300}
														height={screenWidthRef.current > 810 ? 400 : 300}
														className={`imagepointer replaceImage_${index + 2} printHideImage`}
													/> */}
													<div id={`zoomImage_${index + 2}`} className="zoom cbProductZoom  " imageurl={domainNameRef.current.concat(addlImg.addlTopLargeImg)}>
														<img width={screenWidthRef.current > 810 ? 400 : 300} height={screenWidthRef.current > 810 ? 400 : 300} id={index + 2} alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} loading='lazy' src={domainNameRef.current.concat(addlImg.addlTopMediumImg)} onError={handleReplaceLargeImage} onLoad={handleZoomImage} />
													</div>
													{handleZoomImage() == true ? "" : ""}

												</div>
											</>)
										})}
										{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult.galleryJson && containerObject.atgResponse.response.response.standardResult.galleryJson.featureVideosList && containerObject.atgResponse.response.response.standardResult.galleryJson.featureVideosList && containerObject.atgResponse.response.response.standardResult.galleryJson.featureVideosList.map((oneVideo, index) => {
											return (<>
												<div className="carousel-item">
													<Link>
														<ReactPlayerLoader
															id="playlist-player-id"
															playerId="xlAiVNpci"
															accountId="17907428001"
															videoId={oneVideo.videoURL}
															onFailure={onFailure}
															onSuccess={onSuccess}
															options={{
																responsive: true,
																autoplay: false,
																muted: true
															}}
														/>

													</Link>
												</div>
											</>)
										})}
									</div>
									{containerObject.atgResponse.response.response.standardResult.galleryJson.addlImagesList.length >= 1 ? <>
										<button class="carousel-control-prev " type="button" data-bs-target="#pdp-gallery" data-bs-slide="prev">
											<span class="carousel-control-prev-icon" aria-hidden="true"></span>
											<span class="visually-hidden">Previous</span>
										</button>
										<button class="carousel-control-next " type="button" data-bs-target="#pdp-gallery" data-bs-slide="next">
											<span class="carousel-control-next-icon" aria-hidden="true"></span>
											<span class="visually-hidden">Next</span>
										</button></> : ""}
									<div class="carousel-indicators pdp-gallery-thumbnails">
										{containerObject.atgResponse.response.response.standardResult.galleryJson.addlImagesList.length >= 1 ?
											<>
												<button type="button" data-bs-target="#pdp-gallery" data-bs-slide-to="0" className="active" aria-label="Slide 1" aria-current="true">
													<img alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} onError={replaceImage} src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryJson.thumbnailImg)} />
												</button>
												{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryJson.addlImagesList.map((addlImg, index) => {
													return (<>
														<button type="button" data-bs-target="#pdp-gallery" data-bs-slide-to={index + 1} c aria-label={`Slide ${index + 2}`} aria-current="true">
															<img alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} onError={replaceImage} src={domainNameRef.current.concat(addlImg.addlThumbnailImg)} />
														</button>
													</>)
												})}

												{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.galleryJson.featureVideosList && containerObject.atgResponse.response.response.standardResult.galleryJson.featureVideosList.map((videoImg, index) => {
													return (
														<button class="video-thumb" type="button" data-bs-target="#pdp-gallery" data-bs-slide-to={containerObject.atgResponse.response.response.standardResult.galleryJson.addlImagesList.length + index + 1} aria-label={`Slide ${containerObject.atgResponse.response.response.standardResult.galleryJson.addlImagesList.length + index + 1}`}>

															<img alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} onError={replaceImage} src={domainNameRef.current.concat(videoImg.videoThumbnailPath)} />

															<div class="video-thumb-overlay">
																<i class="bi bi-play-circle"></i>
																<span>Video</span>
															</div>
														</button>)
												})}
											</> : ""}</div>
								</div>
							</div>

							<div className="col-12 col-md-6 order-3 d-flex align-items-center justify-content-center">


								{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.pdp_ose_contactus_message ?
									<div class="os-pdp-btn-wrapper" dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.standardResult.pdp_ose_contactus_message }}></div> : ""}

							</div>
						</div>
					</>
					: ""}

				{/* CBS product ended here */}

				{/* CBS family varient started here */}

				{productTypeRef.current && productTypeRef.current == "CBS Family" ?
					<>


						<div id="body" className={`${screenWidthRef.current >= 1024 ? "row openscied-middle-school-kits" : ""} row os-pdp-section px-0`}>

							<div className="col-12 order-2 order-md-1 printPdpHeader ">

								<div className="row" id="prod-sticky-nav">
									<div className="col prod-nav-title">
										<h1 dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : "" }} />
									</div>
									<div className="col-12 pdp-nav" id="pdp-nav">
										<ul className="row prod-nav-group list-unstyled g-0">
											<li className="col-md-6 col-12 prod-nav-item hide-on-sticky">

												<div className="m0"><span className="fwb ftms">Item #:</span> <span id="pdp-skuId">{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.product ? containerObject.atgResponse.response.response.product : ""}</span></div>
											</li>
											<li className="col prod-nav-item bg-light-grey">
												<Link className="pdp-scroll-to" onClick={() => scrollToView("description")}>
													Description
												</Link>
											</li>
											<li className="col prod-nav-item bg-light-grey">
												<Link className="pdp-scroll-to"
													onClick={() => scrollToView("specification")}
												>
													Specifications
												</Link>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="col-12 col-md-4 col-lg-3 col-xxl-2 order-1 order-md-2 my-4 fdp-gallery fdp-gallery-image-css">
								<div id="pdp-gallery" className="carousel carousel-dark slide" data-bs-ride="false" data-bs-interval="false">
									<div className="carousel-inner pdp-gallery-slides">
										<div className={`carousel-item active modalImage_1`} id="modal-image1" modal-image={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.oseFamilyProductPDP && containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson && containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson.largeImg ? containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson.largeImg : ""} onClick={() => handleProductImage(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.oseFamilyProductPDP && containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson && containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson.largeImg ? containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson.largeImg : "")}>
											<img id="1" alt="" style={{ "width": "220px", "height": "220px" }} className="printShowImage" onError={handleReplaceLargeImage} src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.oseFamilyProductPDP && containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson && containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson.largeImg ? containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson.largeImg : "")} />
											<Link>

												{/* <Zoom
													img={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.oseFamilyProductPDP && containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson && containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson.largeImg ? containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson.largeImg : "")}
													zoomScale={3}
													width={220}
													height={220}

													className="imagepointer replaceImage_1 printHideImage"
												/> */}

												<div id="zoomImage_1" className="zoom cbFamilyZoom " imageurl={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.oseFamilyProductPDP && containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson && containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson.largeImg ? containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson.largeImg : "")}>
													<img id="1" className="ose-img-fluid" height={220} alt={containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.displayName ? containerObject.atgResponse.response.response.displayName : ""} loading='lazy' src={domainNameRef.current.concat(containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.oseFamilyProductPDP && containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson && containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson.largeImg ? containerObject.atgResponse.response.response.oseFamilyProductPDP.galleryJson.largeImg : "")} onError={handleReplaceLargeImage} onLoad={handleZoomImage} />
												</div>
												{handleZoomImage() == true ? "" : ""}
											</Link>
										</div>
									</div>
								</div>
							</div>






							<div className="col-12 col-md-8 col-lg-9 col-xxl-9 order-3 d-none d-md-block mt-5 mb-4 ose-pdp-price">
								<div className="row pdp-desc">
									{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.shortDescription ? <div className="col-12 d-none d-md-block" dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.shortDescription }} /> : ""}

								</div>
							</div>
						</div>
						<section class="row fdp-items openscied-middle-school-kits-products">
							<div class="col-md-12 fdp__items">
								<h2 class="h2 d-none d-md-block">{containerObject.atgResponse.response.response.oseFamilyProductPDP.familyItem.familyProductList.length > 0 ? containerObject.atgResponse.response.response.oseFamilyProductPDP.familyItem.familyProductList.length : ""} Product Options</h2>
								<ul class="col-12 list-unstyled">
									{containerObject.atgResponse.response.response.oseFamilyProductPDP && containerObject.atgResponse.response.response.oseFamilyProductPDP.familyItem && containerObject.atgResponse.response.response.oseFamilyProductPDP.familyItem.familyProductList && containerObject.atgResponse.response.response.oseFamilyProductPDP.familyItem.familyProductList.map((oneItems) => {
										return (<>
											<li class="fdp-item">
												<div className="row align-items-center">
													<div className="col-12 col-md-8">
														<div className="row align-items-center g-0 fdp-item-desc">
															<div className="col-12 col-md-12 d-flex">
																<div className="fdp-item-img">
																	<Link to={oneItems.familyProductUrl ? oneItems.familyProductUrl : ""}>
																		<img style={{ "height": "90px" }} alt="/images/fpo/product-400x400.gif" onError={replaceImage} src={domainNameRef.current.concat(oneItems.imageURL ? oneItems.imageURL : "")} />
																	</Link>
																</div>
																<div className="fdp-item-info mt-0">
																	<Link className="fdp-item-title mb-0" to={oneItems.familyProductUrl ? oneItems.familyProductUrl : ""} dangerouslySetInnerHTML={{ __html: oneItems.famProductName ? oneItems.famProductName : "" }}></Link>


																	<div className="fdp-item-status">
																		<span>#{oneItems.skuId ? oneItems.skuId : ""}</span>
																		<span dangerouslySetInnerHTML={{ __html: oneItems.fdp_ose_contactus_message }}></span>

																	</div>
																</div>
															</div>

														</div>
													</div>
													<div className="col-12 col-md-4">
														<div className="row fdp-item-action">
															<div className="col offset-md-6 offset-lg-0">
																<div className="d-flex g-0 pdp-desc-addToCart">
																	{oneItems.cbsInventoryLookUp.add_to_cart == false ? <div class="col fdp-learn-more">
																		<Link title="learn more" to={oneItems.familyProductUrl ? oneItems.familyProductUrl : ""} class="btn-grey">Learn More</Link>
																	</div> : ""
																	}
																</div>
															</div>

														</div>
													</div>
												</div>
											</li>

										</>
										)
									})
									}
								</ul>
							</div>
						</section>
					</>
					: ""}


				{/* CBS family varient ended here */}




				{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.teacherResource && containerObject.atgResponse.response.response.teacherResource ? "" :
					<><div className="row accordion accordion-flush pdp-detail-info openscied-middle-school-kits-products-desc-css" id="pdp-detail-accordion">
						{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.longDescription ?

							<section className="mt-0 col-12 accordion-item pdp-detail-desc" id="description">
								<h2 class="d-block d-md-none accordion-header" id="pdp-desc-heading">
									<button id="description_accordion_button" class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#pdp-desc-body" aria-expanded="false" aria-controls="pdp-desc-body">
										Description
									</button>
								</h2>
								<div id="pdp-desc-body" className="accordionIsTablet accordion-collapse collapse" aria-labelledby="pdp-desc-heading" data-bs-parent="#pdp-detail-accordion">
									<div className="accordion-body">
										<h2 className="d-none d-md-block">Description</h2>
										<div className="row pdp-desc-content">

											{relatedResourcesObjRef.current ?
												<><div className="col-md-9 pdp-desc-detail">
													{ProductTabsDescriptionRef.current ? <div dangerouslySetInnerHTML={{ __html: ProductTabsDescriptionRef.current }} /> : containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.longDescription ? <div dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.longDescription }} /> : ""}
												</div>
													<div class="col-md-3">
														<ul class="pdp-desc-resource ftl list-unstyled">
															{relatedResourcesObjRef.current && relatedResourcesObjRef.current.resourceItemsList && relatedResourcesObjRef.current.resourceItemsList.map((oneResourceItems) => {
																return (<>
																	<li>

																		<Link className="fwb icon-content" onClick={() => handleWarning(oneResourceItems && oneResourceItems.prop65ModalHeader, oneResourceItems && oneResourceItems.description, oneResourceItems && oneResourceItems.icon)} >

																			{iconObjectMap[oneResourceItems && oneResourceItems.categoryIconMap[oneResourceItems.keyValue]]}

																			<span class="icon-text" dangerouslySetInnerHTML={{ __html: oneResourceItems && oneResourceItems.prop65MsgLinkText }}></span>
																		</Link>
																	</li>
																</>)
															})}

															{/* {releatedOrderRef.current && releatedOrderRef.current.map((oneOrder) => {
																return (<> */}
															{relatedResourcesObjRef.current && relatedResourcesObjRef.current.contentItemList && relatedResourcesObjRef.current.contentItemList.map((oneContentItem) => {
																return (<>
																	{/* {oneOrder == oneContentItem.contentMediaType ? */}
																	<li>
																		{oneContentItem && oneContentItem.pdfPath ?
																			<a target="_blank" href={oneContentItem && oneContentItem.pdfPath ? oneContentItem.pdfPath : ""} title="" class="fwb icon-content">

																				{iconObjectMap[oneContentItem && oneContentItem.categoryIconMap[oneContentItem.keyValue]]}

																				<span class="icon-text" dangerouslySetInnerHTML={{ __html: oneContentItem && oneContentItem.displayName }}></span>
																			</a> :


																			<Link to={oneContentItem && oneContentItem.cUrl ? oneContentItem.cUrl : ""} title="" class="fwb icon-content">

																				{iconObjectMap[oneContentItem && oneContentItem.categoryIconMap[oneContentItem.keyValue]]}

																				<span class="icon-text" dangerouslySetInnerHTML={{ __html: oneContentItem && oneContentItem.displayName }}></span>
																			</Link>}
																	</li>
																	{/* : ""} */}
																</>)
															})}
															{/* </>)
															})} */}


														</ul>
													</div>

												</> :

												<div className="col pdp-desc-detail">

													{ProductTabsDescriptionRef.current ? <div dangerouslySetInnerHTML={{ __html: ProductTabsDescriptionRef.current }} /> : containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.longDescription ? <div dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.longDescription }} /> : ""}
												</div>
											}
										</div>
									</div>
								</div>
							</section>
							: ""}

						{/* specification */}


						{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.pdp_heading_label_specifications || containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.oseFamilyProductPDP && containerObject.atgResponse.response.response.oseFamilyProductPDP.familyItem && containerObject.atgResponse.response.response.oseFamilyProductPDP.familyItem.familyProductsList ?
							<section class="col-12 accordion-item pdp-detail-spec mt-1" id="specification">
								<h2 class="d-block d-md-none accordion-header" id="pdp-spec-heading">
									<button id="specification_accordion_button" class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#pdp-spec-body" aria-expanded="false" aria-controls="pdp-spec-body">
										Specifications
									</button>
								</h2>
								<div id="pdp-spec-body" class="accordionIsTablet accordion-collapse collapse" aria-labelledby="pdp-spec-heading" data-bs-parent="#pdp-detail-accordion">
									<div class="accordion-body">
										<h2 class="d-none d-md-block">Specifications</h2>
										<div class="pdp-spec-content">
											<div>

												<dl>
													{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.hazmatWarning ?
														<>
															<dt>
																{containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp_subheading_label_restriction_info}
															</dt>
															<dd>
																<ul>
																	<li class="icon-content pdm">
																		<i class="bi bi-exclamation-circle-fill"></i>
																		<span class="icon-text" dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.hazmatWarning }}></span>
																	</li>
																</ul>
															</dd>
														</> : ""}
													{/* what include and not include for CBS Product start here */}
													{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.includedItem ?
														<>
															<dt dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp_subheading_label_whats_included }}>

															</dt>
															<dd>
																<ul>
																	{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.includedItem && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.includedItem.map((oneIncludeItem, index) => {
																		return (<>

																			{showMoreRef.current && showMoreRef.current["includedItem"] > index ?
																				oneIncludeItem && oneIncludeItem.includedLinkUrl ?
																					<li>{oneIncludeItem?.includedQty}<a dangerouslySetInnerHTML={{ __html: oneIncludeItem.includedDisplayName }} href={oneIncludeItem && oneIncludeItem.includedLinkUrl}  target="_blank"/></li> :
																					<li dangerouslySetInnerHTML={{ __html: oneIncludeItem && oneIncludeItem.includedQty ? oneIncludeItem.includedQty.concat(" ").concat(oneIncludeItem.includedDisplayName) : oneIncludeItem.includedDisplayName }}></li>
																				: ""}
																		</>)
																	})}
																	<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed ${includedItemLengthRef.current && includedItemLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("includedItem")}>expand to see full list</Link>
																</ul>
															</dd>
														</> : ""}

													{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.notIncludedItem ?
														<>
															<dt >
																Needed But Not Included:
															</dt>
															<dd>
																<ul>
																	{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.notIncludedItem && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.notIncludedItem.map((oneNotIncludeItem, index) => {

																		return (<>

																			{showMoreRef.current && showMoreRef.current["notIncludedItem"] > index ?
																				oneNotIncludeItem && oneNotIncludeItem.excludedLinkUrl ?
																					<li><a href={oneNotIncludeItem.excludedLinkUrl} dangerouslySetInnerHTML={{ __html: oneNotIncludeItem.notIncludedQty ? oneNotIncludeItem.notIncludedQty.concat(" ").concat(oneNotIncludeItem.notIncludedDisplayName) : oneNotIncludeItem.notIncludedDisplayName }}  target="_blank"/></li>
																					:
																					<li dangerouslySetInnerHTML={{ __html: oneNotIncludeItem.notIncludedQty ? oneNotIncludeItem.notIncludedQty.concat(" ").concat(oneNotIncludeItem.notIncludedDisplayName) : oneNotIncludeItem.notIncludedDisplayName }}></li>
																				: ""}
																		</>)
																	})}
																	<a style={{ "cursor": "pointer" }} className={`toggle-list collapsed ${notIncludedItemLengthRef.current && notIncludedItemLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("notIncludedItem")}>expand to see full list</a>
																</ul>
															</dd>
														</> : ""}


													{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.specificationList.length > 0 ?
														<>
															<dt dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp_subheading_label_specs }}>

															</dt>
															<dd>
																<ul>
																	{containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.specificationList.map((oneSpecification, index) => {
																		return (<>

																			{showMoreRef.current && showMoreRef.current["featuredItem"] > index ?

																				<li dangerouslySetInnerHTML={{ __html: oneSpecification && oneSpecification.specificationDisplayName.concat(":").concat(oneSpecification.stringValue) }}></li>
																				: ""}
																		</>)
																	})}
																	<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed ${featuresLengthRef.current && featuresLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("featuredItem")}>expand to see full list</Link>
																</ul>
															</dd>
														</> : ""}
													{/* what include and not include for CBS Product end  here */}
													{/* return policy for CBS Product start  here */}
													{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp_subheading_label_return_policy ?
														<>
															<dt>
																{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.pdp_subheading_label_return_policy}
															</dt>
															<dd>
																<p class="pdp-return-policy pdm" dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications && containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.ose_pdp_return_policy ? containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.ose_pdp_return_policy : containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.ose_pdp_no_return_policy ? containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.ose_pdp_no_return_policy : containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.ose_pdp__dl_return_policy ? containerObject.atgResponse.response.response.standardResult.tabsResult.pdpspecifications.ose_pdp__dl_return_policy : "" }}></p>
															</dd>
														</>
														: ""}
													{/* return policy for CBS Product end here */}

													{/* what include and not include for family tabs Product start here */}
													{/* {containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean ?
														<>

															{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.familyVariyantProductDetails && containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.skus.map((oneSku, index) => {
																return (<>
																	{oneSku && oneSku.skuId === selectSkuResultRef.current ? <>



																		{oneSku.specifications.shippingInformation && oneSku.specifications.shippingInformation.length > 0 ? <>
																			<dt>{containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.staticLabels.shippingInfo}</dt>
																			<dd>
																				<ul>
																					<li class="icon-content pdm">
																						<i class="bi bi-exclamation-circle-fill"></i>
																						<span class="icon-text" dangerouslySetInnerHTML={{ __html: oneSku.specifications.shippingInformation && oneSku.specifications.shippingInformation }}></span>
																					</li>
																				</ul>
																			</dd>
																		</> : ""}

																		{oneSku.specifications.whatsIncludedList && oneSku.specifications.whatsIncludedList.length > 0 ?
																			<>
																				<dt dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.staticLabels.includedList }}>

																				</dt>
																				<dd>
																					<ul>
																						{oneSku.specifications.whatsIncludedList.map((oneIncludeItem, index) => {
																							return (<>

																								{showMoreRef.current && showMoreRef.current["includedItem"] > index ?
																									oneIncludeItem.linkUrl ?
																										<li> <a href={oneIncludeItem.linkUrl} dangerouslySetInnerHTML={{ __html: oneIncludeItem && oneIncludeItem.description }} /></li> :
																										<li dangerouslySetInnerHTML={{ __html: oneIncludeItem && oneIncludeItem.description }}></li>
																									: ""}
																							</>)
																						})}
																						<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed ${includedItemLengthRef.current && includedItemLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("familyProductIncludedItem")}>expand to see full list</Link>
																					</ul>
																				</dd>
																			</> : ""}

																		{oneSku.specifications.whatsExcludedList && oneSku.specifications.whatsExcludedList.length > 0 ?
																			<>
																				<dt dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.staticLabels.excludedList }}>

																				</dt>
																				<dd>
																					<ul>
																						{oneSku.specifications.whatsExcludedList.map((oneNotIncludeItem, index) => {
																							return (<>

																								{showMoreRef.current && showMoreRef.current["notIncludedItem"] > index ?
																									oneNotIncludeItem.linkUrl ?
																										<li> <a href={oneNotIncludeItem.linkUrl} dangerouslySetInnerHTML={{ __html: oneNotIncludeItem && oneNotIncludeItem.description }} /></li> :
																										<li dangerouslySetInnerHTML={{ __html: oneNotIncludeItem && oneNotIncludeItem.description }}></li>
																									: ""}
																							</>)
																						})}
																						<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed ${notIncludedItemLengthRef.current && notIncludedItemLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("familyProductNotIncludedItem")}>expand to see full list</Link>
																					</ul>
																				</dd>
																			</> : ""}

																		{oneSku.specifications.specs && oneSku.specifications.specs.length > 0 ?
																			<>
																				<dt dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.staticLabels.specFeatures }}>
																				</dt>
																				<dd>
																					<ul>
																						{oneSku.specifications.specs.map((oneSpecs, index) => {
																							return (<>

																								{showMoreRef.current && showMoreRef.current["featuredItem"] > index ?

																									<li dangerouslySetInnerHTML={{ __html: oneSpecs && oneSpecs }}></li>
																									: ""}
																							</>)
																						})}
																						<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed ${featuresLengthRef.current && featuresLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("familyProductFeaturedItem")}>expand to see full list</Link>
																					</ul>
																				</dd>
																			</> : ""}

																		{oneSku.specifications.returnPolicy ? <>
																			<dt>{containerObject.atgResponse.response.response.familyVariyantProductDetails.productVariantsResult.masterProductBean.staticLabels.returnPolicy}</dt>
																			<dd>
																				<p class="pdp-return-policy pdm" dangerouslySetInnerHTML={{ __html: oneSku.specifications.returnPolicy && oneSku.specifications.returnPolicy }}></p>

																			</dd>
																		</> : ""}


																	</> : ""}
																</>)
															})}
														</> : ""} */}

													{containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.oseFamilyProductPDP && containerObject.atgResponse.response.response.oseFamilyProductPDP.familyItem && containerObject.atgResponse.response.response.oseFamilyProductPDP.familyItem.familyProductsList ?
														<div class="spec-prod-select">
															<form >
																<div class="row align-items-center">
																	<div class="col-auto">
																		<label for="fdp-spec-selection" class="form-label">Choose an Item:</label>
																	</div>
																	<div class="col-12 col-md-auto">
																		<select id="fdp-spec-selection" class="form-select" onChange={specification} >
																			<option selected="selected" disabled="disabled">&nbsp;</option>
																			{containerObject.atgResponse.response.response.oseFamilyProductPDP.familyItem.familyProductsList.map((oneProductList) => {
																				return (
																					<option value={oneProductList.id} dangerouslySetInnerHTML={{ __html: "#".concat(oneProductList.id).concat(" - ").concat(oneProductList.displayName) }}></option>)
																			})}
																		</select>
																	</div>
																</div>
															</form>

															{productSpecficationDetailsRef.current ? <>

																{productSpecficationDetailsRef.current.familyProduct.hazmatWarning ? <>
																	<dt>{productSpecficationDetailsRef.current.familyProduct.pdp_subheading_label_restriction_info}</dt>
																	<dd>

																		<ul>
																			<li class="icon-content pdm">
																				<i class="bi bi-exclamation-circle-fill"></i>
																				<span class="icon-text" dangerouslySetInnerHTML={{ __html: productSpecficationDetailsRef.current.familyProduct.hazmatWarning }}>
																					
																				</span>
																			</li>
																		</ul>
																		

																	</dd>
																</> : ""}

																{productSpecficationDetailsRef.current.familyProduct.includedItem && productSpecficationDetailsRef.current.familyProduct.includedItem.length > 0 ?
																	<>
																		<dt dangerouslySetInnerHTML={{ __html: productSpecficationDetailsRef.current.familyProduct.pdp_subheading_label_whats_included }}>

																		</dt>
																		<dd>
																			<ul>
																				{productSpecficationDetailsRef.current.familyProduct.includedItem.map((oneIncludeItem, index) => {
																					return (<>

																						{showMoreRef.current && showMoreRef.current["includedItem"] > index ?
																							oneIncludeItem && oneIncludeItem.excludedLinkUrl ?

																							<li>{oneIncludeItem.includedQty ? oneIncludeItem.includedQty : ""} <a href={oneIncludeItem?.excludedLinkUrl} dangerouslySetInnerHTML={{ __html: oneIncludeItem?.includedDisplayName }}  target="_blank"/></li>
																								:
																								<li dangerouslySetInnerHTML={{ __html: oneIncludeItem.includedQty ? oneIncludeItem.includedQty.concat(" ").concat(oneIncludeItem?.includedDisplayName) : oneIncludeItem?.includedDisplayName }}></li>  

																								// <li dangerouslySetInnerHTML={{ __html: oneIncludeItem && oneIncludeItem.includedQty.concat(" ").concat(oneIncludeItem.includedDisplayName) }}></li>

																								// : <li dangerouslySetInnerHTML={{ __html: oneIncludeItem && oneIncludeItem.includedDisplayName }}></li>
																							: ""}
																					</>)
																				})}
																				<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed ${includedItemLengthRef.current && includedItemLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("familyVarientincludedItem")}>expand to see full list</Link>
																			</ul>
																		</dd>
																	</> : ""}

																{productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.notIncludedItem && productSpecficationDetailsRef.current.familyProduct.notIncludedItem.length > 0 ?
																	<>
																		<dt>
																			Needed But Not Included:
																		</dt>
																		<dd>
																			<ul>
																				{productSpecficationDetailsRef.current.familyProduct.notIncludedItem.map((oneNotIncludeItem, index) => {
																					return (<>

																						{showMoreRef.current && showMoreRef.current["notIncludedItem"] > index ?

																							oneNotIncludeItem && oneNotIncludeItem.excludedLinkUrl ?
																								<li>{oneNotIncludeItem.notIncludedQty ? oneNotIncludeItem.notIncludedQty : ""} <a href={oneNotIncludeItem?.excludedLinkUrl} dangerouslySetInnerHTML={{ __html: oneNotIncludeItem?.notIncludedDisplayName }}  target="_blank"/></li>
																								:
																								<li dangerouslySetInnerHTML={{ __html: oneNotIncludeItem.notIncludedQty ? oneNotIncludeItem.notIncludedQty.concat(" ").concat(oneNotIncludeItem.notIncludedDisplayName) : oneNotIncludeItem.notIncludedDisplayName }}></li>
																							: ""}
																					</>)
																				})}
																				<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed ${notIncludedItemLengthRef.current && notIncludedItemLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("familyVarientnotIncludedItem")}>expand to see full list</Link>
																			</ul>
																		</dd>
																	</> : ""}

																{productSpecficationDetailsRef.current.familyProduct && productSpecficationDetailsRef.current.familyProduct.specificationList && productSpecficationDetailsRef.current.familyProduct.specificationList.length > 0 ?
																	<>
																		<dt dangerouslySetInnerHTML={{ __html: productSpecficationDetailsRef.current.familyProduct.pdp_subheading_label_specs }}>
																		</dt>
																		<dd>
																			<ul>
																				{productSpecficationDetailsRef.current.familyProduct.specificationList.map((oneSpecs, index) => {
																					return (<>

																						{showMoreRef.current && showMoreRef.current["featuredItem"] > index ?

																							<li dangerouslySetInnerHTML={{ __html: oneSpecs && oneSpecs.specificationDisplayName.concat(":").concat(oneSpecs.stringValue) }}></li>
																							: ""}
																					</>)
																				})}
																				<Link style={{ "cursor": "pointer" }} className={`toggle-list collapsed ${featuresLengthRef.current && featuresLengthRef.current > ItemLength ? "d-block" : "d-none"}`} onClick={() => handleShowMore("familyVarientfeaturedItem")}>expand to see full list</Link>
																			</ul>
																		</dd>
																	</> : ""}




																{productSpecficationDetailsRef.current.familyProduct.ose_pdp_return_policy ? <>
																	<dt>{productSpecficationDetailsRef.current.familyProduct.pdp_subheading_label_return_policy}</dt>
																	<dd>
																		<p class="pdp-return-policy pdm" dangerouslySetInnerHTML={{ __html: productSpecficationDetailsRef.current.familyProduct.ose_pdp_return_policy }}></p>

																	</dd>
																</> : ""}</>

																: ""}

														</div> : ""}
												</dl>
											</div>
										</div>

									</div>
								</div>
							</section>
							: ""}

					</div>

						{/* need help */}
						{isDlproductRef.current == false ? "" :
							<div class="pdp-detail-info border-0 pdp-detail-moreinfo">

								<div class="c-container dl-need-help" dangerouslySetInnerHTML={{ __html: containerObject.atgResponse.response.response && containerObject.atgResponse.response.response.standardResult && containerObject.atgResponse.response.response.standardResult.tabsResult && containerObject.atgResponse.response.response.standardResult.tabsResult.pdp_dl_product_help }}>

								</div>
							</div>}
					</>}
			</div >
		</> : ""
		}
	</>);
}
export default ProductDetailsContainer;
